"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;
Object.defineProperty(exports, "SelectComponent", {
  enumerable: true,
  get: function get() {
    return _SelectComponent["default"];
  }
});
Object.defineProperty(exports, "SelectFormik", {
  enumerable: true,
  get: function get() {
    return _SelectFormik["default"];
  }
});

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _formik = require("formik");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _index = require("../index");

var _index2 = require("../TextInput/index.styles");

var _ErrorMessage = _interopRequireDefault(require("../ErrorMessage"));

var _SelectComponent = _interopRequireDefault(require("./SelectComponent"));

var _SelectFormik = _interopRequireDefault(require("./SelectFormik"));

var _excluded = ["children", "showError"],
    _excluded2 = ["onChange"];

var Select = function Select(_ref) {
  var children = _ref.children,
      showError = _ref.showError,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useField = (0, _formik.useField)(props),
      _useField2 = (0, _slicedToArray2["default"])(_useField, 2),
      field = _useField2[0],
      meta = _useField2[1];

  var hasError = typeof showError === 'undefined' ? meta.error && meta.touched : showError;
  var disabled = props.disabled; // we extract the onChange property, because we deal with it
  // as part of the InputFormik component

  var onChange = field.onChange,
      otherFieldOptions = (0, _objectWithoutProperties2["default"])(field, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_index2.StyledLabel, {
    disabled: disabled ? true : undefined
  }, children, /*#__PURE__*/_react["default"].createElement(_formik.Field, (0, _extends2["default"])({
    component: _SelectFormik["default"],
    disabled: disabled ? true : undefined
  }, otherFieldOptions, props, {
    className: hasError ? 'invalid' : null
  }))), hasError ? /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], {
    "data-testid": "error-".concat(field.name)
  }, meta.error) : null);
};

exports.Select = Select;
Select.propTypes = {
  showError: _propTypes.bool,
  children: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
    type: (0, _propTypes.oneOf)([_index.FieldLabel])
  })]),
  name: _propTypes.string.isRequired,
  size: (0, _propTypes.oneOf)(['xs', 's', 'm', 'l', 'xl']),
  disabled: _propTypes.bool,
  isMulti: _propTypes.bool
};
Select.defaultProps = {
  size: 'm',
  disabled: false,
  isMulti: false
};